import { useMemo } from 'react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';

import { ButtonLinkV2 } from '@/components/common/Button';
import { StyledParagraph } from '@/components/common/MarkUp';

export interface NavigationLinkProps {
  title: string;
  additionalText?: string;
  url: string;
  tabIndex?: number;
}

const NavigationLink = ({
  title,
  additionalText,
  url,
  tabIndex,
}: NavigationLinkProps) => {
  const { asPath } = useRouter();
  const ariaCurrent = useMemo<'page' | null>(
    () => (url === asPath ? 'page' : null),
    [url, asPath],
  );

  return (
    <LinkContainer>
      <ButtonLink
        hasIcon
        backgroundOfParent="white"
        size="sm"
        variant="text"
        href={url}
        className="tracking-nav__link"
        ariaCurrent={ariaCurrent}
        tabIndex={tabIndex}
      >
        {title}
      </ButtonLink>
      <LinkDescription size="body-sm">{additionalText}</LinkDescription>
    </LinkContainer>
  );
};

const LinkContainer = styled.div`
  padding: var(--spacing-50) 0;
`;

const ButtonLink = styled(ButtonLinkV2)`
  padding-left: 0;
`;

const LinkDescription = styled(StyledParagraph)`
  color: var(--colour-deep-space-700);
`;

export { NavigationLink };
